<template>
  <div class="submenu  " v-if="sub">
    <div class="">

      <router-link to="/ueberuns/marken-kommunikation" :class="{'active':slides}" class="d-flex d-md-none links">
        Über uns
      </router-link>
      <router-link to="/kontakt" class="d-flex d-md-none links">
        Kontakt
      </router-link>
      <a @click="openRefs" class="d-flex d-md-none links">
        Arbeiten
      </a>

      <router-link to="/impressum"> Impressum</router-link>
      <router-link to="/datenschutz">Datenschutzerklärung</router-link>
      <a class="close" @click="closeSub" style="cursor: pointer;padding: 10px 20px;">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L13 13M13 1L1 13" stroke="#ffffff"/>
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Velocity from "velocity-animate";
import jQuery from "jquery";
import store from '@/store'

export default {
  Velocity,
  store,
  name: 'Home',
  components: {},
  data() {
    return {}
  },
  created: function () {
  },
  props: {
    refs: Boolean,
    sub: Boolean
  },
  computed: {
    slides: function () {
      return this.$route.meta.slides
    },
  },
  methods: {
    closeSub() {
      this.$emit('update:sub', false)
    },

    openRefs() {
      this.$emit('update:refs', true)
    },
  }
}
</script>
<style scoped lang="scss">
.submenu {
  height: 40px;
  top: 72px;
  padding: 0 50px 0 0;
  display: flex;
  background-color: $zzcolor;
  position: fixed;
  width: 100%;
  justify-content: space-between;
  opacity: 1;
  z-index: 999999;
  @include mobile {
    height: auto;
    flex-direction: column;
    padding: 0;
border-bottom: 2px solid $zzcolor;
  }

  & > div {
    display: flex;
    justify-content: flex-end;

    .links {

    }

    @include mobile {
      flex-direction: column;
      align-items: flex-end;
      .links {
        order: 2;
        flex-direction: column;
        align-items: flex-end;
      }
    }
    width: 100%;

    a {
      &.router-link-active {
        background-color: #fff;
        color: $zzcolor;
      }

      color: #fff;
      display: flex;
      width: 100%;
      //styleName: <nav> - items;
      font-family: $sansmed;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      letter-spacing: 0.1em;
      flex-direction: column;
      align-items: flex-end;
      padding: 0 20px;
      text-transform: uppercase;
      @include mobile {
        font-size: 16px;
        order: 3;
        &.close {
          order: 1;
        }
      }

    }
  }
}
</style>